import checkDoHaveMapMarkers from './checkDoHaveMapMarkers';

const checkDoShowMap = (store) => checkDoHaveMapMarkers(store) && store.tripSearch.isMapShown;
export default checkDoShowMap;
